export default "__VITE_ASSET__Da8jnwC5__"